import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/app-layout";
import { FileSearch } from "lucide-react";

export const Route = createFileRoute("/rfp-review")({
  head: () => ({
    meta: [
      { title: "RFP Review — AskBell" },
      { name: "description", content: "AI-powered RFP analysis and response tool" },
    ],
  }),
  component: RfpReviewPage,
});

function RfpReviewPage() {
  return (
    <AppLayout>
      <div className="flex-1 flex flex-col items-center justify-center text-center p-8">
        <div className="flex h-16 w-16 items-center justify-center rounded-ui-md bg-primary/10 text-primary mb-4">
          <FileSearch className="h-8 w-8" />
        </div>
        <h1 className="text-ui-2xl font-bold text-foreground mb-2">RFP Review</h1>
        <p className="text-ui-base text-muted-foreground max-w-md mb-6">
          Upload an RFP and associated documents for AI-powered analysis of requirements,
          research approaches, and response strategies — with dual-model cross-validation.
        </p>
        <div className="inline-flex items-center gap-2 rounded-full bg-secondary px-4 py-2 text-ui-sm font-bold text-muted-foreground">
          Coming soon
        </div>
      </div>
    </AppLayout>
  );
}
